import {createHistory} from 'create-history';
import Keycloak from 'keycloak-js';
import queryString from 'query-string';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import {Provider} from 'react-redux';
import {syncHistoryWithStore} from 'react-router-redux';
import {createStore} from 'redux';
import {
  populateAqfxDataAsync,
  populateAwsDataAsync,
  populateBurnPrescriptionsAsync,
  populateFmsDataAsync,
  populateIndicatorDetailsAsyncPromise,
  populateManualWeatherAsync,
  setCentreMessage,
  setQsStationId,
  storageEvent,
  updatePointDetails
} from './actions';
import * as ActionTypes from './actions/actionTypes';
import {setMapMinZoom, setMinimalMapControls} from './actions/populate_map_details';
import App from './App';
import appConfig from './config/app_settings';
import {disableAuth, urlBase} from './config/environment.js';
import mapConfig from './config/map_settings';
import middleware from './middleware';
import reducers from './reducers';
import {clearUrlHash, destoreUrlHash, storeUrlHash} from './utils/url_utils';

require('dotenv').config();

const store = createStore(reducers, middleware);

const initialise = (kcToken) => {
  let station_mode = false;

  // Parse the query string
  if (window.location.search) {
    const qs = queryString.parse(window.location.search);
    const station_id = qs['station_id'];
    if (station_id) {
      station_mode = true;
      clearUrlHash();
      store.dispatch(setQsStationId(station_id));
    }
    // Remove the query string
    window.history.replaceState(null, '', window.location.pathname);
  }

  if (!station_mode && !store.getState().indicators.active && !store.getState().view.popup_open) {
    store.dispatch(setCentreMessage('To start, choose an indicator or select a point to view forecast data.'));
  }

  // These ones need to be called in order.
  store.dispatch(populateIndicatorDetailsAsyncPromise()).then(() => store.dispatch(updatePointDetails()));

  store.dispatch(populateBurnPrescriptionsAsync());
  store.dispatch(populateManualWeatherAsync());
  store.dispatch(populateAwsDataAsync());
  store.dispatch(populateFmsDataAsync(kcToken));
  store.dispatch(populateAqfxDataAsync());

  // Below screen width of 900px allow map to zoom out to extent where whole of Victoria is visible on most mobiles.
  if (document.documentElement.offsetWidth < 900) {
    store.dispatch(setMapMinZoom(mapConfig.settings.minZoomMobile));
  }
  if (document.documentElement.offsetWidth < 700) {
    store.dispatch(setMinimalMapControls());
  }
  destoreUrlHash();
  if (appConfig.google_analytics) {
    ReactGA.initialize(appConfig.google_analytics.tracking_id);
    ReactGA.pageview(appConfig.google_analytics.pageview);
  }

  window.addEventListener('storage', (event) => {
    store.dispatch(storageEvent(event));
  });
};

// This is all we need to do sync browser history with the location
// state in the store.
syncHistoryWithStore(
  createHistory(),
  store
);

const rootElement = document.getElementById('root');

const app = <Provider store={store}><App/></Provider>;

const unauthorised = <div>Access denied</div>;

if (disableAuth) {
  initialise();
  ReactDOM.render(app, rootElement);
  store.dispatch({ type: ActionTypes.SET_KEYCLOAK_DISABLED });
} else {
  const slash = urlBase && !urlBase.endsWith('/') ? '/' : '';
  const kc = Keycloak(`${urlBase}${slash}keycloak.json`);
  storeUrlHash();
  kc.init({ onLoad: 'login-required' }).success(authenticated => {
    if (authenticated) {
      store.dispatch({ type: ActionTypes.SET_KEYCLOAK, data: kc });

      setInterval(() => {
        kc.updateToken(10).error(() => kc.logout());
      }, 10000);

      initialise(kc.token);
      ReactDOM.render(app, rootElement);
    } else {
      ReactDOM.render(unauthorised, rootElement);
    }
  }).error((e) => {
    console.error('Error from KeyCloak: ' + e);
  });
}



// WEBPACK FOOTER //
// ./src/index.js